import { createElement } from 'react';
import { Checkbox } from '@alifd/next';
import './index.scss';
const OadpCheckbox = function OadpCheckbox({ id, name, defaultChecked, label, disabled, ...otherProps }) {
    return (createElement(Checkbox, Object.assign({ id: id, name: name, defaultChecked: defaultChecked, label: label, disabled: disabled }, otherProps)));
};
export default OadpCheckbox;
